import { I18n } from '@aws-amplify/core';
import { message, notification } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import Api from '@/services/api';
import { BaseContext } from '@/types';
import { ROSA_QUERY_KEYS } from './query-keys';

export type DeleteImageResponse = any;

export type DeleteImageRequest = BaseContext & {
	report_id: string;
	image_id: string;
};

async function deleteImage(body: DeleteImageRequest): Promise<DeleteImageResponse> {
	const { image_id } = body;
	const url = `/ergonomic-tool/rosa/images/${image_id}`;
	const { data } = await Api.delete<DeleteImageResponse>(url, { params: body });
	return data;
}

export const useDeleteImage = () => {
	const queryClient = useQueryClient();

	return useMutation((body: DeleteImageRequest) => deleteImage(body), {
		onError: (err: any) => {
			const typeError = err.response.data.details[0].split('" ');
			notification.error({
				message: I18n.get('Ops... something happened!'),
				description: I18n.get(typeError[1])
			});
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries([ROSA_QUERY_KEYS.GET_ROSA_IMAGES]);
			message.success(I18n.get('Image deleted successfully'));
		}
	});
};
